import * as React from 'react'
import './product-banner.css'

export default class ProductBanner extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const content = this.props.content

    return (
      <div className="product-banner ">
        <div className="scroll">
          Skrunaðu <span className="arrow" /> <span className="arrow" />{' '}
          <span className="arrow" />{' '}
        </div>
        {content !== undefined &&
          Object.keys(content).map((key) => {
            const image = {
              backgroundImage: `url(${content[key].fields?.mynd?.fields?.file.url})`,
            }

            return (
              <div className="item-container block" key={key}>
                <span>{content[key].fields.smallEntry}</span>
                <h1>{content[key].fields.largeHeader}</h1>
                <div className="product-banner-smaller-text">
                  {content[key].fields.description}
                </div>
                <div className="product-banner-image" style={image} />
              </div>
            )
          })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product-page/product-banner/product-banner.tsx